import { Box, Icon, LoaderNew, TextInputNew as TextInput, TextInputNewProps } from '@jfs/ui-new'
import { useCallback } from 'react'

interface SearchBarProps {
  onSearchClick: any
  iconType: 'LOADING' | 'SEARCH' | 'CLOSE'
  onChange: any
}

export const SearchBar = ({ onChange, onSearchClick, iconType, text }: SearchBarProps) => {
  const onTextChange = useCallback(
    (text: any) => {
      const re = /^[0-9\b]+$/
      if ((text === '' || re.test(text)) && text.length < 11) {
        onChange(text)
      }
    },
    [onChange],
  )
  return (
    <Box marginHorizontal={16}>
      <TextInput
        {...styles.container}
        editable={iconType !== 'CLOSE'}
        rightComponent={
          <Box
            onPress={() => onSearchClick(iconType)}
            backgroundColor={'PRIMARY'}
            paddingVertical={8}
            paddingHorizontal={16}
            disabled={text.length !== 10}
            opacity={text?.length === 10 ? 1 : 0.6}
            borderRadius={8}
            underlayColor={'PRIMARY'}>
            {iconType === 'LOADING' && <LoaderNew type={'small'} color={'WHITE'} />}
            {(iconType === 'SEARCH' || iconType === 'CLOSE') && <Icon id={iconType as any} color="WHITE" size={24} />}
          </Box>
        }
        value={text}
        onChange={onTextChange}
        placeholder={'Search By Remitter Mobile No.'}
      />
    </Box>
  )
}

const styles = {
  container: {
    flexDirection: 'row',
    borderWidth: 1,
    justifyContent: 'center',
    width: '100%',
    borderColor: 'ITEM_SEPARATOR',
    borderRadius: 8,
    paddingLeft: 16,
    fontSize: 12,
    focusBorderColor: 'PRIMARY',
    fontFamily: 'jioType-medium',
    color: 'BLACK_75',
    placeholderTextColor: 'SECONDARY_GREY',
  } as TextInputNewProps,
}
